export const removedSurgeString = 'Successfully removed surge from service';
export const noSurgeAmountString = 'Please enter an amount.';
export const addSurgeOverlayTitle = 'Add surge pricing';
export const addSurgeOverlayDescription = 'Including decimals. Example $20.00';
export const addSurgeButton = 'add surge';
export const addSurgePlaceholder = 'surge amount...';
export const addSurgeLabel = 'SURGE AMOUNT';
export const addSurgeBoostLabel = 'Surge boost';
